"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialCommentsApi = exports.SocialCommentsApiFactory = exports.SocialCommentsApiFp = exports.SocialCommentsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * SocialCommentsApi - axios parameter creator
 * @export
 */
var SocialCommentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a comment or reply for a submission
         * @param {CreateCommentDto} createCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerCreateCommentV1: function (createCommentDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createCommentDto_1], args_1, true), void 0, function (createCommentDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createCommentDto' is not null or undefined
                            (0, common_1.assertParamExists)('commentsControllerCreateCommentV1', 'createCommentDto', createCommentDto);
                            localVarPath = "/v1/social/comments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCommentDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a comment for a submission
         * @param {DeleteCommentDto} deleteCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerDeleteCommentV1: function (deleteCommentDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteCommentDto_1], args_1, true), void 0, function (deleteCommentDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deleteCommentDto' is not null or undefined
                            (0, common_1.assertParamExists)('commentsControllerDeleteCommentV1', 'deleteCommentDto', deleteCommentDto);
                            localVarPath = "/v1/social/comments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteCommentDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get replies for a specific comment
         * @param {string} commentId Comment ID to get replies for
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentRepliesV1: function (commentId_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([commentId_1, page_1, limit_1], args_1, true), void 0, function (commentId, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'commentId' is not null or undefined
                            (0, common_1.assertParamExists)('commentsControllerGetCommentRepliesV1', 'commentId', commentId);
                            localVarPath = "/v1/social/comments/replies/{commentId}"
                                .replace("{".concat("commentId", "}"), encodeURIComponent(String(commentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get comments for a submission
         * @param {string} submissionId Submission ID to get comments for
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetSubmissionCommentsV1: function (submissionId_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([submissionId_1, page_1, limit_1], args_1, true), void 0, function (submissionId, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'submissionId' is not null or undefined
                            (0, common_1.assertParamExists)('commentsControllerGetSubmissionCommentsV1', 'submissionId', submissionId);
                            localVarPath = "/v1/social/comments/{submissionId}"
                                .replace("{".concat("submissionId", "}"), encodeURIComponent(String(submissionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a comment for a submission
         * @param {UpdateCommentDto} updateCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerUpdateCommentV1: function (updateCommentDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateCommentDto_1], args_1, true), void 0, function (updateCommentDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'updateCommentDto' is not null or undefined
                            (0, common_1.assertParamExists)('commentsControllerUpdateCommentV1', 'updateCommentDto', updateCommentDto);
                            localVarPath = "/v1/social/comments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCommentDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SocialCommentsApiAxiosParamCreator = SocialCommentsApiAxiosParamCreator;
/**
 * SocialCommentsApi - functional programming interface
 * @export
 */
var SocialCommentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SocialCommentsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a comment or reply for a submission
         * @param {CreateCommentDto} createCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerCreateCommentV1: function (createCommentDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentsControllerCreateCommentV1(createCommentDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SocialCommentsApi.commentsControllerCreateCommentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a comment for a submission
         * @param {DeleteCommentDto} deleteCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerDeleteCommentV1: function (deleteCommentDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentsControllerDeleteCommentV1(deleteCommentDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SocialCommentsApi.commentsControllerDeleteCommentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get replies for a specific comment
         * @param {string} commentId Comment ID to get replies for
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentRepliesV1: function (commentId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentsControllerGetCommentRepliesV1(commentId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SocialCommentsApi.commentsControllerGetCommentRepliesV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get comments for a submission
         * @param {string} submissionId Submission ID to get comments for
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetSubmissionCommentsV1: function (submissionId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentsControllerGetSubmissionCommentsV1(submissionId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SocialCommentsApi.commentsControllerGetSubmissionCommentsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a comment for a submission
         * @param {UpdateCommentDto} updateCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerUpdateCommentV1: function (updateCommentDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commentsControllerUpdateCommentV1(updateCommentDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SocialCommentsApi.commentsControllerUpdateCommentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SocialCommentsApiFp = SocialCommentsApiFp;
/**
 * SocialCommentsApi - factory interface
 * @export
 */
var SocialCommentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SocialCommentsApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a comment or reply for a submission
         * @param {CreateCommentDto} createCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerCreateCommentV1: function (createCommentDto, options) {
            return localVarFp.commentsControllerCreateCommentV1(createCommentDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a comment for a submission
         * @param {DeleteCommentDto} deleteCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerDeleteCommentV1: function (deleteCommentDto, options) {
            return localVarFp.commentsControllerDeleteCommentV1(deleteCommentDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get replies for a specific comment
         * @param {string} commentId Comment ID to get replies for
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentRepliesV1: function (commentId, page, limit, options) {
            return localVarFp.commentsControllerGetCommentRepliesV1(commentId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get comments for a submission
         * @param {string} submissionId Submission ID to get comments for
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Items per page (default: 20, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetSubmissionCommentsV1: function (submissionId, page, limit, options) {
            return localVarFp.commentsControllerGetSubmissionCommentsV1(submissionId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a comment for a submission
         * @param {UpdateCommentDto} updateCommentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerUpdateCommentV1: function (updateCommentDto, options) {
            return localVarFp.commentsControllerUpdateCommentV1(updateCommentDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SocialCommentsApiFactory = SocialCommentsApiFactory;
/**
 * SocialCommentsApi - object-oriented interface
 * @export
 * @class SocialCommentsApi
 * @extends {BaseAPI}
 */
var SocialCommentsApi = /** @class */ (function (_super) {
    __extends(SocialCommentsApi, _super);
    function SocialCommentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a comment or reply for a submission
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialCommentsApi
     */
    SocialCommentsApi.prototype.commentsControllerCreateCommentV1 = function (createCommentDto, options) {
        var _this = this;
        return (0, exports.SocialCommentsApiFp)(this.configuration).commentsControllerCreateCommentV1(createCommentDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a comment for a submission
     * @param {DeleteCommentDto} deleteCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialCommentsApi
     */
    SocialCommentsApi.prototype.commentsControllerDeleteCommentV1 = function (deleteCommentDto, options) {
        var _this = this;
        return (0, exports.SocialCommentsApiFp)(this.configuration).commentsControllerDeleteCommentV1(deleteCommentDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get replies for a specific comment
     * @param {string} commentId Comment ID to get replies for
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Items per page (default: 20, max: 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialCommentsApi
     */
    SocialCommentsApi.prototype.commentsControllerGetCommentRepliesV1 = function (commentId, page, limit, options) {
        var _this = this;
        return (0, exports.SocialCommentsApiFp)(this.configuration).commentsControllerGetCommentRepliesV1(commentId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get comments for a submission
     * @param {string} submissionId Submission ID to get comments for
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Items per page (default: 20, max: 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialCommentsApi
     */
    SocialCommentsApi.prototype.commentsControllerGetSubmissionCommentsV1 = function (submissionId, page, limit, options) {
        var _this = this;
        return (0, exports.SocialCommentsApiFp)(this.configuration).commentsControllerGetSubmissionCommentsV1(submissionId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a comment for a submission
     * @param {UpdateCommentDto} updateCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialCommentsApi
     */
    SocialCommentsApi.prototype.commentsControllerUpdateCommentV1 = function (updateCommentDto, options) {
        var _this = this;
        return (0, exports.SocialCommentsApiFp)(this.configuration).commentsControllerUpdateCommentV1(updateCommentDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SocialCommentsApi;
}(base_1.BaseAPI));
exports.SocialCommentsApi = SocialCommentsApi;
